<h1 mat-dialog-title>Pobieranie opłat trwa dłużej niż zwykle</h1>

<p>W tym przypadku pobieranie opłat może zająć nawet do kilku godzin.</p>

<p>Poinformujemy Cię, gdy pobieranie się zakończy. W tym czasie możesz dodać innego dostawcę.</p>

<div mat-dialog-actions align="start">
  <button mat-raised-button color="primary" matDialogClose>Kontynuuj w tle</button>
</div>
